import React from 'react';
import { ErrorMessage } from 'components';

export class ErrorBoundary extends React.Component {
    public state = {
        hasError: false,
        message: '',
    };

    constructor(props) {
        super(props);
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            message: error + '',
        };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <ErrorMessage message={this.state.message} />;
        }

        return this.props.children;
    }
}